import { render, staticRenderFns } from "./ChildrenComponent.vue?vue&type=template&id=5f527ab9"
import script from "./ChildrenComponent.vue?vue&type=script&lang=js"
export * from "./ChildrenComponent.vue?vue&type=script&lang=js"
import style0 from "./ChildrenComponent.vue?vue&type=style&index=0&id=5f527ab9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports